var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	39361: () => (loadSingleton("default", "react", false, () => (__webpack_require__.e(2155).then(() => (() => (__webpack_require__(22155))))))),
	89722: () => (loadSingleton("default", "react/jsx-runtime", false, () => (__webpack_require__.e(8104).then(() => (() => (__webpack_require__(65723))))))),
	90900: () => (loadSingleton("default", "@tanstack/react-query", false, () => (__webpack_require__.e(2752).then(() => (() => (__webpack_require__(42752))))))),
	99757: () => (loadSingleton("default", "react-router", false, () => (__webpack_require__.e(5751).then(() => (() => (__webpack_require__(35751))))))),
	58206: () => (loadSingleton("default", "@grafana/faro-web-sdk", false, () => (__webpack_require__.e(3504).then(() => (() => (__webpack_require__(73504))))))),
	87570: () => (loadSingleton("default", "react-dom/client", false, () => (Promise.all([__webpack_require__.e(2285), __webpack_require__.e(8997)]).then(() => (() => (__webpack_require__(58997))))))),
	12329: () => (loadSingleton("default", "capitalrx-shell", false, () => (Promise.all([__webpack_require__.e(5011), __webpack_require__.e(5293), __webpack_require__.e(3192), __webpack_require__.e(6255), __webpack_require__.e(2285), __webpack_require__.e(6956), __webpack_require__.e(8045), __webpack_require__.e(6286), __webpack_require__.e(2503), __webpack_require__.e(4809), __webpack_require__.e(7558), __webpack_require__.e(9246), __webpack_require__.e(9263), __webpack_require__.e(3639), __webpack_require__.e(3535), __webpack_require__.e(4031), __webpack_require__.e(2079), __webpack_require__.e(9586), __webpack_require__.e(9709), __webpack_require__.e(309)]).then(() => (() => (__webpack_require__(79709))))))),
	39893: () => (loadSingleton("default", "@grafana/faro-react", false, () => (__webpack_require__.e(7704).then(() => (() => (__webpack_require__(57704))))))),
	78120: () => (loadSingleton("default", "@grafana/faro-web-tracing", false, () => (__webpack_require__.e(1560).then(() => (() => (__webpack_require__(11560))))))),
	82285: () => (loadSingleton("default", "react-dom", false, () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(9361)]).then(() => (() => (__webpack_require__(70316))))))),
	56286: () => (loadSingleton("default", "react-hook-form", false, () => (__webpack_require__.e(6288).then(() => (() => (__webpack_require__(76288))))))),
	32503: () => (loadSingleton("default", "capitalrx-utilities", false, () => (Promise.all([__webpack_require__.e(5011), __webpack_require__.e(6771), __webpack_require__.e(6902), __webpack_require__.e(314)]).then(() => (() => (__webpack_require__(77668))))))),
	74809: () => (loadSingleton("default", "capitalrx-shell-auth", false, () => (__webpack_require__.e(6117).then(() => (() => (__webpack_require__(18498))))))),
	59263: () => (loadSingleton("default", "capitalrx-components-2.0/lib/utilities", false, () => (__webpack_require__.e(6909).then(() => (() => (__webpack_require__(79290))))))),
	73639: () => (loadSingleton("default", "capitalrx-components-2.0/lib/typography", false, () => (__webpack_require__.e(8452).then(() => (() => (__webpack_require__(46071))))))),
	33535: () => (loadSingleton("default", "capitalrx-components-2.0/lib/layout", false, () => (Promise.all([__webpack_require__.e(6956), __webpack_require__.e(7834)]).then(() => (() => (__webpack_require__(66956))))))),
	4031: () => (loadSingleton("default", "capitalrx-components-2.0/lib/general", false, () => (Promise.all([__webpack_require__.e(5011), __webpack_require__.e(5293), __webpack_require__.e(3192), __webpack_require__.e(2285), __webpack_require__.e(6956), __webpack_require__.e(8045), __webpack_require__.e(6286), __webpack_require__.e(2503), __webpack_require__.e(4809), __webpack_require__.e(7558)]).then(() => (() => (__webpack_require__(7558))))))),
	32079: () => (loadSingleton("default", "capitalrx-components-2.0/lib/general/HotKeys", false, () => (Promise.all([__webpack_require__.e(5011), __webpack_require__.e(5293), __webpack_require__.e(2285), __webpack_require__.e(6956), __webpack_require__.e(8045)]).then(() => (() => (__webpack_require__(63595))))))),
	59586: () => (loadSingleton("default", "capitalrx-components-2.0/lib/general/Color", false, () => (__webpack_require__.e(2237).then(() => (() => (__webpack_require__(62237))))))),
	22072: () => (loadSingleton("default", "react-router", false, () => (__webpack_require__.e(3970).then(() => (() => (__webpack_require__(81589))))))),
	5086: () => (loadSingleton("default", "react/jsx-dev-runtime", false, () => (__webpack_require__.e(9121).then(() => (() => (__webpack_require__(79121))))))),
	42217: () => (loadSingleton("default", "react-router-dom", false, () => (Promise.all([__webpack_require__.e(8765), __webpack_require__.e(1893), __webpack_require__.e(2285), __webpack_require__.e(2072)]).then(() => (() => (__webpack_require__(21893))))))),
	26877: () => (loadSingleton("default", "capitalrx-components-2.0", false, () => (Promise.all([__webpack_require__.e(5011), __webpack_require__.e(5293), __webpack_require__.e(3192), __webpack_require__.e(4603), __webpack_require__.e(6255), __webpack_require__.e(6771), __webpack_require__.e(1789), __webpack_require__.e(2285), __webpack_require__.e(6956), __webpack_require__.e(8045), __webpack_require__.e(6286), __webpack_require__.e(2503), __webpack_require__.e(4809), __webpack_require__.e(7558), __webpack_require__.e(5921), __webpack_require__.e(9246), __webpack_require__.e(992)]).then(() => (() => (__webpack_require__(45009))))))),
	31327: () => (loadSingleton("default", "capitalrx-components-2.0/lib/general/HotKeys/constants", false, () => (__webpack_require__.e(3440).then(() => (() => (__webpack_require__(53440))))))),
	8597: () => (loadSingleton("default", "capitalrx-components-2.0/lib/forms", false, () => (Promise.all([__webpack_require__.e(5011), __webpack_require__.e(5293), __webpack_require__.e(3192), __webpack_require__.e(4603), __webpack_require__.e(2285), __webpack_require__.e(6956), __webpack_require__.e(8045), __webpack_require__.e(6286), __webpack_require__.e(2503), __webpack_require__.e(4809), __webpack_require__.e(7558), __webpack_require__.e(5921)]).then(() => (() => (__webpack_require__(75921))))))),
	89851: () => (loadSingleton("default", "capitalrx-components-2.0/lib/tokens", false, () => (__webpack_require__.e(5970).then(() => (() => (__webpack_require__(55970)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"1256": [
		90900,
		99757
	],
	"1327": [
		31327
	],
	"2072": [
		22072
	],
	"2079": [
		32079
	],
	"2217": [
		42217
	],
	"2285": [
		82285
	],
	"2503": [
		32503
	],
	"3535": [
		33535
	],
	"3639": [
		73639
	],
	"4031": [
		4031
	],
	"4809": [
		74809
	],
	"5086": [
		5086
	],
	"6146": [
		12329,
		39893,
		78120
	],
	"6286": [
		56286
	],
	"6877": [
		26877
	],
	"7570": [
		87570
	],
	"8206": [
		58206
	],
	"8597": [
		8597
	],
	"9263": [
		59263
	],
	"9361": [
		39361
	],
	"9586": [
		59586
	],
	"9722": [
		89722
	],
	"9851": [
		89851
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}